// Generated by ReScript, PLEASE EDIT WITH CARE

import * as Js_dict from "../../../../../node_modules/rescript/lib/es6/js_dict.js";
import * as Belt_List from "../../../../../node_modules/rescript/lib/es6/belt_List.js";
import * as Belt_Array from "../../../../../node_modules/rescript/lib/es6/belt_Array.js";
import * as Belt_Option from "../../../../../node_modules/rescript/lib/es6/belt_Option.js";
import * as Timestamp$Catalyst from "../../../../../node_modules/@porterin/catalyst/src/entities/time-stamp/Timestamp.bs.js";

function orderStatusToString(status) {
  switch (status) {
    case /* Open */0 :
        return "Open";
    case /* NoResponse */1 :
        return "No response";
    case /* CallBack */2 :
        return "Call back";
    case /* PaymentPending */3 :
        return "Payment pending";
    case /* NotInterested */4 :
        return "Not interested";
    case /* Initiated */5 :
        return "Initiated";
    case /* Paid */6 :
        return "Paid";
    
  }
}

function orderStatusToApiString(status) {
  switch (status) {
    case /* Open */0 :
        return "OPEN";
    case /* NoResponse */1 :
        return "NO_RESPONSE";
    case /* CallBack */2 :
        return "CALLBACK";
    case /* PaymentPending */3 :
        return "PAYMENT_PENDING";
    case /* NotInterested */4 :
        return "NOT_INTERESTED";
    case /* Initiated */5 :
        return "INITIATED";
    case /* Paid */6 :
        return "PAID";
    
  }
}

var allOrderStatuses = [
  /* Open */0,
  /* NoResponse */1,
  /* CallBack */2,
  /* PaymentPending */3,
  /* NotInterested */4,
  /* Initiated */5
];

function orderStatusFromString(status) {
  switch (status) {
    case "CALLBACK" :
    case "Call back" :
        return /* CallBack */2;
    case "INITIATED" :
    case "Initiated" :
        return /* Initiated */5;
    case "NO_RESPONSE" :
    case "No response" :
        return /* NoResponse */1;
    case "NOT_INTERESTED" :
    case "Not interested" :
        return /* NotInterested */4;
    case "OPEN" :
    case "Open" :
        return /* Open */0;
    case "PAID" :
    case "Paid" :
        return /* Paid */6;
    case "PAYMENT_PENDING" :
    case "PENDING" :
    case "Payment pending" :
        return /* PaymentPending */3;
    default:
      return /* Open */0;
  }
}

function getStatusBadgeVariant(status) {
  switch (status) {
    case /* NoResponse */1 :
        return /* BadgeError */1;
    case /* PaymentPending */3 :
    case /* NotInterested */4 :
        return /* BadgeWarning */3;
    case /* CallBack */2 :
    case /* Initiated */5 :
        return /* BadgeDefault */2;
    case /* Open */0 :
    case /* Paid */6 :
        return /* BadgeSuccess */0;
    
  }
}

var allCities = [
  "Chennai",
  "Pune",
  "Surat",
  "Mumbai",
  "Bangalore"
];

var statusOptions = [
  /* CallBack */2,
  /* NotInterested */4,
  /* NoResponse */1
];

function updateItemSize(items, itemId, newSize) {
  return Belt_Array.map(items, (function (i) {
                if (i.id !== itemId) {
                  return i;
                }
                var v = Belt_Array.getBy(i.variants, (function (v) {
                        return v.sizeCode === newSize;
                      }));
                var newSku;
                if (v !== undefined) {
                  newSku = v.sku;
                } else {
                  var parts = i.sku.split("-");
                  var len = parts.length;
                  if (len > 0) {
                    Belt_Array.set(parts, len - 1 | 0, newSize);
                    newSku = parts.join("-");
                  } else {
                    newSku = i.sku;
                  }
                }
                return {
                        id: i.id,
                        productCode: i.productCode,
                        sku: newSku,
                        name: i.name,
                        price: i.price,
                        size: newSize,
                        availableSizes: i.availableSizes,
                        variants: i.variants,
                        imageUrl: i.imageUrl,
                        hasValidation: i.hasValidation
                      };
              }));
}

function formatDate(isoString) {
  var date = new Date(isoString);
  if (Number.isNaN(date.getTime())) {
    return isoString;
  }
  var day = String(date.getDate() | 0);
  var month = String(date.getMonth() + 1.0 | 0);
  var year = String(date.getFullYear() | 0);
  var pad = function (s) {
    if (s.length < 2) {
      return "0" + s;
    } else {
      return s;
    }
  };
  return pad(day) + "/" + pad(month) + "/" + year;
}

function formatDateWithTime(isoString) {
  var date = new Date(isoString);
  if (Number.isNaN(date.getTime())) {
    return isoString;
  } else {
    return Timestamp$Catalyst.toString(Timestamp$Catalyst.make(date.getTime()), "DD MMMM YYYY, HH:mm");
  }
}

function getGeoRegionName(geoRegions, geoRegionId) {
  return Belt_Option.mapWithDefault(Belt_List.getBy(geoRegions, (function (r) {
                    return r.id === geoRegionId;
                  })), "", (function (r) {
                return r.name;
              }));
}

function mapApiOrderToStoreOrder(geoRegions, order) {
  return {
          orderId: order.order_uuid,
          orderNumber: order.order_number,
          createdOn: order.created_at,
          orderStatus: orderStatusFromString(Belt_Option.getWithDefault(order.crm_status, order.status)),
          partnerName: Belt_Option.getWithDefault(Belt_Option.flatMap(order.requester, (function (r) {
                      return r.name;
                    })), ""),
          city: getGeoRegionName(geoRegions, Belt_Option.getWithDefault(order.geo_region_id, 0)),
          phoneNumber: Belt_Option.getWithDefault(Belt_Option.flatMap(order.requester, (function (r) {
                      return r.phone;
                    })), ""),
          agentName: "",
          accessedAt: order.updated_at
        };
}

function mapApiOrderDetailToOrderDetail(geoRegions, detail) {
  var address = detail.address;
  var match = detail.requester;
  var partnerName = match !== undefined ? (
      Belt_Option.getWithDefault(match.name, "") !== "" ? Belt_Option.getWithDefault(match.name, "") : (
          address !== undefined ? address.receiver_name : ""
        )
    ) : (
      address !== undefined ? address.receiver_name : ""
    );
  var match$1 = detail.requester;
  var phoneNumber = match$1 !== undefined ? (
      Belt_Option.getWithDefault(match$1.phone, "") !== "" ? Belt_Option.getWithDefault(match$1.phone, "") : (
          address !== undefined ? address.receiver_phone : ""
        )
    ) : (
      address !== undefined ? address.receiver_phone : ""
    );
  var sizesByProduct = {};
  var variantsByProduct = {};
  return {
          order: {
            orderId: detail.order_uuid,
            orderNumber: detail.order_number,
            createdOn: detail.created_at,
            orderStatus: orderStatusFromString(Belt_Option.getWithDefault(detail.crm_status, detail.status)),
            partnerName: partnerName,
            city: Belt_Option.mapWithDefault(address, getGeoRegionName(geoRegions, Belt_Option.getWithDefault(detail.geo_region_id, 0)), (function (a) {
                    return a.city;
                  })),
            phoneNumber: phoneNumber,
            agentName: "",
            accessedAt: detail.updated_at
          },
          partnerId: Belt_Option.getWithDefault(Belt_Option.flatMap(detail.requester, (function (r) {
                      return Belt_Option.map(r.user_id, (function (prim) {
                                    return String(prim);
                                  }));
                    })), ""),
          addressLine1: Belt_Option.mapWithDefault(address, "", (function (a) {
                  return a.address_line_1;
                })),
          addressLine2: Belt_Option.mapWithDefault(address, "", (function (a) {
                  return a.address_line_2;
                })),
          state: Belt_Option.mapWithDefault(address, "", (function (a) {
                  return a.state;
                })),
          pincode: Belt_Option.mapWithDefault(address, "", (function (a) {
                  return a.postal_code;
                })),
          items: (Belt_Array.forEach(detail.items, (function (item) {
                    var code = item.product.code;
                    var sizes = Js_dict.get(sizesByProduct, code);
                    var existingSizes = sizes !== undefined ? sizes : [];
                    var variants = Js_dict.get(variantsByProduct, code);
                    var existingVariants = variants !== undefined ? variants : [];
                    var sizeCode = item.variant.size_code;
                    var alreadyExists = Belt_Array.some(existingSizes, (function (s) {
                            return s === sizeCode;
                          }));
                    if (!alreadyExists) {
                      sizesByProduct[code] = Belt_Array.concat(existingSizes, [sizeCode]);
                      variantsByProduct[code] = Belt_Array.concat(existingVariants, [{
                              sku: item.variant.sku,
                              sizeCode: sizeCode
                            }]);
                      return ;
                    }
                    
                  })), Belt_Array.map(detail.items, (function (item) {
                    var sizes = Js_dict.get(sizesByProduct, item.product.code);
                    var availableSizes = sizes !== undefined ? sizes : [];
                    var v = Js_dict.get(variantsByProduct, item.product.code);
                    var variants = v !== undefined ? v : [];
                    return {
                            id: item.product.code + "-" + item.variant.sku,
                            productCode: item.product.code,
                            sku: item.variant.sku,
                            name: item.product.name,
                            price: Belt_Option.getWithDefault(item.unit_price_minor, 0) / 100 | 0,
                            size: item.variant.size_code,
                            availableSizes: availableSizes,
                            variants: variants,
                            imageUrl: Belt_Option.getWithDefault(item.product.image_url, ""),
                            hasValidation: false
                          };
                  }))),
          lastUpdatedBy: partnerName,
          lastUpdatedAt: detail.updated_at
        };
}

function mapOrderProductsToStoreItems(products) {
  return Belt_Array.map(products, (function (product) {
                var variants = Belt_Array.map(product.variants, (function (v) {
                        return {
                                sku: v.sku,
                                sizeCode: v.size_code
                              };
                      }));
                var availableSizes = Belt_Array.map(product.variants, (function (v) {
                        return v.size_code;
                      }));
                var firstVariant = Belt_Array.get(product.variants, 0);
                var match = firstVariant !== undefined ? [
                    firstVariant.sku,
                    firstVariant.size_code
                  ] : [
                    "",
                    ""
                  ];
                return {
                        id: "prod_" + product.code,
                        productCode: product.code,
                        sku: match[0],
                        name: product.name,
                        price: product.price_minor / 100 | 0,
                        size: match[1],
                        availableSizes: availableSizes,
                        variants: variants,
                        imageUrl: Belt_Option.mapWithDefault(Belt_Array.get(product.images, 0), "", (function (img) {
                                return img.image_url;
                              })),
                        hasValidation: Belt_Option.getWithDefault(product.has_validation, false)
                      };
              }));
}

export {
  orderStatusToString ,
  orderStatusToApiString ,
  allOrderStatuses ,
  orderStatusFromString ,
  getStatusBadgeVariant ,
  allCities ,
  statusOptions ,
  updateItemSize ,
  formatDate ,
  formatDateWithTime ,
  getGeoRegionName ,
  mapApiOrderToStoreOrder ,
  mapApiOrderDetailToOrderDetail ,
  mapOrderProductsToStoreItems ,
  
}
/* Timestamp-Catalyst Not a pure module */
